import React from 'react';
import { EntityForm } from '../../widgets/Forms';
import { CustomTextField } from '../../widgets/CustomTextField';
import { Row, Col } from 'react-bootstrap';



export default function WorkReadinessProgrammeSetupSearchForm(props) {

    return (
        <EntityForm ref={React.createRef()} viewId="WorkReadinessProgrammesetup" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form => <form className={form.classes.container} id="WorkReadinessProgramme">
                <div className="row search-form-container">
                    <div className="col form-col">
                        <CustomTextField
                            id="SchoolName"
                            label="School Name"
                            className="w-100"
                            onKeyPress={props.onKeyUp}
                            InputProps={{
                                readOnly: false,
                            }}
                            form={form}
                        />
                    </div>
                </div>
            </form>
            }
        </EntityForm>
    );
}
